<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <!-- Contenet page started-->
  <div class="row">
    <div class="col-md-12">
      <!-- breadcrumb -->
      <div class="page-breadcrumb">
        <ul class="page-breadcrumb__trail">
          <li><a>Manage</a></li>
          <li><a *ngIf="this.loginPersonType == 'EMPLOYEE'">Material</a><a
            *ngIf="this.loginPersonType != 'EMPLOYEE'">Inventory Control</a></li>
          <li><a>Farm Spend Analysis</a></li>
        </ul>
        <div class="page-breadcrumb__icons">
          <a routerLink="/home"><img src="assets/images/New_Icons/home-transprent-icon.svg" title="Home"></a>
        </div>
      </div>
    </div>
    <div class="block">
      <div class="page-header">
        <span class="page-header__title">Farm Spend Analysis</span>
      </div>
      <div class="Reports_form_div">
        <form class="form-horizontal" id="myForm" role="form" novalidate [formGroup]="registerForm">
          <div class="reports-form-container" (clickOutside)="isDropdownOpen = false">
            <mat-form-field appearance="outline" class="w-100" floatLabel="always" *ngIf="loginPersonType == 'EMPLOYEE'">
              <mat-label>Search Business Name</mat-label>
              <!-- search box powered by mat‑autocomplete -->
              <input matInput type="text" id="businessname" autocomplete="off" formControlName="businessfield"
                     placeholder="Search business" (keyup)="filterBusinesses($event)"
                     (click)="isDropdownOpen = true" (focus)="filteredOptions = businessEntites"
                     [matAutocomplete]="businessAuto"/>
              <mat-autocomplete #businessAuto="matAutocomplete" (optionSelected)="selectOption($event.option.value)">
                <mat-option *ngFor="let option of filteredOptions" [value]="option">
                  {{ option.businessName }}
                </mat-option>
              </mat-autocomplete>
              <mat-hint *ngIf="f.businessfield.invalid"><i>Select business</i></mat-hint>
              <mat-hint *ngIf="f.businessfield.valid"><i>Business selected</i></mat-hint>
              <mat-error *ngIf="(submitted || f.businessfield.touched || f.businessfield.dirty) && f.businessfield.errors">
                <i *ngIf="f.businessfield.hasError('required')">Required.</i>
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Farm Site</mat-label>
              <mat-select id="location" formControlName="location" name="location" (click)="isDropdownOpen = false"
                          [(ngModel)]="transaction.farm_site_id" (selectionChange)="getAllpondsByFarmsiteId()">
                <mat-option value="undefined" disabled>Select Farm site</mat-option>
                <mat-option *ngFor="let farmsite of farmsites" [value]="farmsite.id">
                  {{ (farmsite?.farmNameAtLocation) }}
                </mat-option>
              </mat-select>
              <mat-hint *ngIf="f.location.invalid"><i>Select farm site</i></mat-hint>
              <mat-hint *ngIf="f.location.valid"><i>Farm site selected</i></mat-hint>
              <mat-error *ngIf="(submitted || f.location.touched || f.location.dirty) && f.location.errors">
                <i *ngIf="f.location.hasError('required')">Required.</i>
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Pond</mat-label>
              <mat-select id="pond" formControlName="pond" name="pond" (click)="isDropdownOpen = false"
                          [(ngModel)]="transaction.pond_id" (selectionChange)="getCultureByPondId(); onPondSelect()">
                <mat-option value="undefined" disabled>Select Tank</mat-option>
                <mat-option *ngIf="customerPonds && customerPonds.length>0" [value]="''">All</mat-option>
                <mat-option *ngFor="let pond of customerPonds" [value]="pond.pond_id"> {{ (pond?.name) }} </mat-option>
              </mat-select>
              <mat-hint *ngIf="f.pond.invalid"><i>Select pond</i></mat-hint>
              <mat-hint *ngIf="f.pond.valid"><i>Pond selected</i></mat-hint>
              <mat-error *ngIf="submitted && f.pond.errors">
                <i *ngIf="f.pond.hasError('required')">Required.</i>
              </mat-error>
              <!--<mat-error *ngIf="!pondsAvailable">
                <i>Tanks are not available for this site.</i>
              </mat-error>-->
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-100" *ngIf="singleDatePickerFlag">
              <mat-label>Culture</mat-label>
              <mat-select id="culturedata" formControlName="culture" name="culture" (click)="isDropdownOpen = false"
                          [(ngModel)]="transaction.pond_culture_id">
                <mat-option value="undefined" disabled>Select Culture</mat-option>
                <mat-option *ngFor="let culture of pondCultures" [value]="culture.id"> {{ (culture?.culture_identifier) }} </mat-option>
              </mat-select>
              <mat-hint *ngIf="f.culture.invalid"><i>Select culture</i></mat-hint>
              <mat-hint *ngIf="f.culture.valid"><i>Culture selected</i></mat-hint>
              <mat-error *ngIf="submitted && f.culture.errors">
                <i *ngIf="f.culture.hasError('required')">Required.</i>
              </mat-error>
            </mat-form-field>
            <!-- Date Range Picker (visible when 'All' is selected) -->
            <mat-form-field appearance="outline" class="w-100" *ngIf="!singleDatePickerFlag">
              <mat-label>By Date Range</mat-label>
              <mat-date-range-input [rangePicker]="picker" [formGroup]="dateRangeField" [max]="maxDate"
                                    (focus)="picker.open()" (click)="picker.open()">
                <input matStartDate placeholder="Start date" formControlName="start" readonly />
                <input matEndDate placeholder="End date" formControlName="end" readonly />
              </mat-date-range-input>
              <button mat-icon-button [ngStyle]="{ 'z-index': 1000, 'position': 'relative', 'background': 'none', 'border': 'none', 'box-shadow': 'none', 'outline': 'none'}" matSuffix (click)="picker.open()" aria-label="Toggle date">
                <mat-icon>calendar_today</mat-icon>
              </button>
              <mat-date-range-picker #picker (closed)="onPickerClosed()"></mat-date-range-picker>
              <mat-hint><i>Date range selected</i></mat-hint>
            </mat-form-field>

            <!-- Single Date Picker (visible when specific pond is selected) -->
             <mat-form-field appearance="outline" class="w-100" *ngIf="singleDatePickerFlag">
              <mat-label>Till Date</mat-label>
              <input matInput [matDatepicker]="picker" [formControl]="transactionDateControl" placeholder="Choose date" readonly [max]="maxDate"/>
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
              <mat-hint *ngIf="transactionDateControl.value">
                <i>Selected: {{ transactionDateControl.value | date: 'dd-MMM-yyyy' }}</i>
              </mat-hint>
            </mat-form-field>
          </div>
        </form>
        <div>
          <div class="buttons-div reports_search_div">
            <div class="transactions-button-container">
              <button class="transaction-submit-button" (click)="onSubmit()" [disabled]="submitButtonDisabled">
                <span class="icon"><img src="../../../../../assets/images/New_Icons/search-icon.svg"></span>
                <span class="text">Search</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="block">
      <div [hidden]="!searchLoad">
        <div class="adjust loader-container">
          <div class="loader2"></div>
        </div>
      </div>
      <div [hidden]="!searchFlag" style="overflow:auto;width: 98%;">
        <div>
          <div *ngIf="categoryFlag" id="wrapper_1">
            <span class="dataSpan" style="padding-left: 238px;padding-top: 230px;">Value in Rupees</span>
            <span class="dataColorTable">
                <table class="tableAlignment">
                  <tbody>
                    <tr *ngFor="let record of categoriesResultArray">
                      <td><span [ngStyle]="{'background-color': record.color}" class="colorBox"></span></td>
                      <td style="text-align: left;">{{ record.categoryName }}</td>
                      <td style="text-align: right;">{{ record.displayExpense }} </td>
                    </tr>
                  </tbody>
                </table>
              </span>
            <div style="display: flex;align-items: center;justify-content: space-between;border-top: 1px solid black;
              padding-top: 10px;">
              <span>Total Value</span>
              <span style="font-weight: 700;">₹   {{ totalExpenseCostValue }}</span>
            </div>
            <span *ngIf="itemFlag" class="dataSpan"
                  style="padding-left: 238px;padding-top: 205px;">Value in Rupees</span>
            <span *ngIf="itemFlag" [ngClass]="itemsResultsArray.length > 10 ? 'scrollClass' : ''"
                  class="dataColorTable">
                <table class="tableAlignment">
                  <tbody>
                    <tr *ngFor="let record of itemsResultsArray">
                      <td style="padding-right: 10px;"><span [ngStyle]="{'background-color': record.color}"
                                                             class="colorBox"></span></td>
                      <td style="text-align: left;padding-left: 4px;">{{ record.categoryName }}<span
                        *ngIf="record && record.subType">-</span> {{ record && record.subType }}</td>
                      <td style="text-align: right;">{{ record.displayExpense }}</td>
                    </tr>
                  </tbody>
                </table>
              </span>
          </div>
          <div style="width: 72%;display: flow-root;border-left: 2px solid #DFE5E5;">
            <div class="tab-content">
              <div class="tab-pane fade in active" id="culture" style="position: relative;">
                <div [hidden]="!categoryFlag">
                  <ul class="nav nav-tabs batch">
                    <li class="active" style="padding-left: 5px;padding-top: 2px;"><a data-toggle="tab" href=""
                                                                                      style="font-size: 18px;">Culture</a>
                    </li>
                  </ul>
                </div>
                <div [hidden]="!categoryFlag" style="margin-top: 2px;padding-left: 210px;">
                  <canvas height="100%" id="pie-chart" width="100%"></canvas>
                </div>
                <div *ngIf="pondSelectedFlag" class="expenditureSpan">
                    <span class="alignmentSPan"><i>T.Exp: &nbsp; &nbsp; ₹ &nbsp;
                    <span style="font-size: 20px;">{{ totalExpenditure }}</span></i></span>
                  <span class="alignmentSPan"><i>T.Biomass: &nbsp; &nbsp;
                    <span style="font-size: 20px;"> {{ totalBiomass }} </span> &nbsp; Kg </i></span>
                  <span class="alignmentSPan">
                      <i>Production cost: &nbsp; &nbsp; ₹ &nbsp;
                        <span style="font-size: 20px;"> {{ productionCost }}</span> &nbsp;
                        <span *ngIf="ponduse == 2">/piece</span>
                        <span *ngIf="ponduse != 2">Kg</span>
                      </i>
                    </span>
                </div>
                <div [hidden]="!itemFlag" id="canvasarea" style="padding-left: 118px;">
                  <div id="pieItemChart"></div>
                </div>
              </div>
              <div class="tab-pane fade" id="prep">
                <h3>Preparatory Block</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>





